import Autocomplete from "@mui/material/Autocomplete"
import Link from "@mui/material/Link"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import Column from "../../../common/components/Column"
import { useBaseSelectSMSCampaignState } from "./SelectSMSCampaignDialog"
import {
  TemplateGroupTabs,
  useTemplatePickerTab,
} from "./templateGroups"

export default function SelectSMSCampaignAutoComplete({
  selectedCampaign,
  setSelectedCampaign,
  campaignInputValue,
  setCampaignInputValue,
  availableCampaigns,
  availableCampaignsOptions,
  campaignsLoaded,
  onCreateLinkClicked,
}) {
  const messageHeader =
    availableCampaigns.length === 0
      ? "No campaigns found. Create your first "
      : "Not finding your SMS template? Create a new template "

  function handleCreateLinkClicked(e) {
    e.preventDefault()
    onCreateLinkClicked()
  }

  const { tab, setTab, options } = useTemplatePickerTab(
    availableCampaignsOptions
  )

  return (
    <Column sx={{ gap: 1 }}>
      <TemplateGroupTabs tab={tab} onChange={setTab} />
      <Autocomplete
        value={selectedCampaign}
        onChange={(_, newValue) => setSelectedCampaign(newValue)}
        inputValue={campaignInputValue}
        onInputChange={(_, newValue) => setCampaignInputValue(newValue)}
        options={options}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField {...params} label="Select template" />
        )}
        noOptionsText={
          tab === "default"
            ? "No default templates"
            : "No templates in this account"
        }
        fullWidth
      />
      {campaignsLoaded && onCreateLinkClicked && (
        <Typography variant="body1">
          {messageHeader}
          <Link
            to="/campaigns/sms/create"
            variant="body1"
            onClick={handleCreateLinkClicked}
            href="#"
          >
            here
          </Link>
          .
        </Typography>
      )}
    </Column>
  )
}

export function useSelectSMSCampaignAutoCompleteState(
  open,
  campaignsAPIURL = "/workflows/api/sms/select-campaign/"
) {
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [campaignInputValue, setCampaignInputValue] = useState("")
  const { availableCampaigns, setAvailableCampaigns, campaignsLoaded } =
    useBaseSelectSMSCampaignState(open, campaignsAPIURL)
  const availableCampaignsOptions = availableCampaigns.map((campaign) => ({
    ...campaign,
    label: campaign.name,
  }))

  return {
    selectedCampaign,
    setSelectedCampaign,
    campaignInputValue,
    setCampaignInputValue,
    availableCampaigns,
    setAvailableCampaigns,
    availableCampaignsOptions,
    campaignsLoaded,
  }
}
